export default function openMiniProgram(appId, orginId, path) {
  return new Promise((resolve, reject) => {
    // https://wiki.imgo.tv/pages/viewpage.action?pageId=6334900#ar.JSSDK%E6%96%87%E6%A1%A3-%E6%89%93%E5%BC%80%E5%BE%AE%E4%BF%A1%E5%B0%8F%E7%A8%8B%E5%BA%8F
    const param = {
      appId, //应用的appid
      orginId, //小程序原始ID 一般gh开头
      path //小程序路径
    };
    console.log('openMiniProgram', param);
    try {
      MgtvApi.callhandler('openWXApplet', param, function(data) {
        console.log('openMiniProgram ok', data);
        resolve();
      });
    } catch (err) {
      console.log('openMiniProgram error', err);
      reject('openMiniProgram error');
    }
  });
}
